import React from 'react';
import ReactDOM from 'react-dom/client'; // 使用 createRoot API
import { useTranslation } from '@/i18n/client';
import { Backdrop, Typography } from '@mui/material';
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from '@/components/UKLoadingIcon';

const MaskLoadingComponent = ({ open, text }) => {
  const { t } = useTranslation();
  return (
    <Backdrop
      sx={(theme) => ({
        background: 'inherit',
        zIndex: theme.zIndex.drawer + 1,
      })}
      open={open}
      id='loading-mask-internal'
    >
      <div
        style={{
          maxWidth: '248px',
          minHeight: '80px',
          position: 'fixed',
          top: '40%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '6px',
          padding: '20px 0px',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderRadius: '12px',
          zIndex: 9999,
        }}
      >
        <UKLoadingIcon />
        <Typography
          variant='body1'
          component='div'
          sx={{
            color: '#fff',
            fontSize: '14px',
            fontWeight: '700',
            textAlign: 'center',
            boxSizing: 'border-box',
            padding: '0 28.5px',
            wordBreak: 'break-all',
          }}
        >
          {text || `${t('common.pageStatus.loading')}...`}
        </Typography>
      </div>
    </Backdrop>
  );
};

const UKMaskLoading = (() => {
  let root = null;

  const close = () => {
    const maskLoadingElement = document.getElementById('loading-mask');
    maskLoadingElement?.setAttribute('style', 'display: none;');
  };

  const show = (text = '') => {
    const maskLoadingElement = document.getElementById('loading-mask');
    if (!root) {
      root = ReactDOM.createRoot(maskLoadingElement);
      root.render(renderLoading(text));
    } else {
      maskLoadingElement?.setAttribute(
        'style',
        'display: block; z-index: 100000; position: absolute;',
      );
    }
  };

  const renderLoading = ({ text }) => {
    return (
      <>
        <MaskLoadingComponent open={true} text={text} />
      </>
    );
  };

  return { show, close };
})();

export default UKMaskLoading;
